import Select from 'react-select'
import { selectStyles } from 'apps/builder/components/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { Input, TextArea } from 'components/Input/Input'
import { FancyToggle, FancyCheckbox } from 'apps/builder/components/settings/modal'
import { lib } from '@gocanvas/client'
const { CURRENCY_STYLE } = lib

export const ShowThisField = ({
  guid = '',
  pdf_visibility = 0,
  web_visibility = 0,
  showThisFieldType,
}) => {
  const dispatch = useDispatch()

  const optionValues = [
    'Always',
    'Never',
    'Only if field is not empty',
    'Only if default value has been changed',
    'Only if default value has been changed & field is not empty',
    showThisFieldType === 'pdf' &&
      'Only to addresses set on the Email Options Page',
  ]

  const options = optionValues.map((optionValue, index) => ({
    label: optionValue,
    value: index,
  }))

  const pdfOptionValue =
    options.find(({ value }) => value == pdf_visibility) || options[0]

  const webOptionValue =
    options.find(({ value }) => value == web_visibility) || options[0]

  return (
    <div className="show-this-field">
      <div className="label-floating">
        <Select
          styles={selectStyles}
          className="input--placeholder default-value--select"
          classNamePrefix="react-select"
          onChange={({ value }) => {
            if (showThisFieldType === 'pdf') {
              dispatch(
                updateEntry({
                  guid,
                  pdf_visibility: value,
                })
              )
            } else {
              dispatch(
                updateEntry({
                  guid,
                  web_visibility: value,
                })
              )
            }
          }}
          options={options}
          value={showThisFieldType === 'pdf' ? pdfOptionValue : webOptionValue}
        />
        <label className="label-default-value">{`Show This Field on ${
          showThisFieldType === 'pdf' ? 'PDF' : 'Web'
        }`}</label>
      </div>
    </div>
  )
}

export const LongTextMobileStyle = ({
  guid = '',
  style = 0
}) => {
  const dispatch = useDispatch()

  const options = [
    {
      label: 'Small',
      value: 2
    },
    {
      label: 'Normal',
      value: 0
    },
    {
      label: 'Large',
      value: 1
    }
  ]

  const styleValue = options.find(({ value }) => value == style)

  const onChange = ({ value }) => dispatch(
    updateEntry({
      guid,
      style: value,
    })
  )

  return (
    <div className="show-this-field">
      <div className="label-floating">
        <Select
          styles={selectStyles}
          className="input--placeholder default-value--select"
          classNamePrefix="react-select"
          onChange={onChange}
          options={options}
          value={styleValue}
        />
        <label className="label-default-value">Mobile Style</label>
      </div>
    </div>
  )
}

export const LabelInput = ({
  guid = '',
  export_label = '',
  receipt_label = '',
  labelType,
}) => {
  const dispatch = useDispatch()

  const updateLabelValue = value => {
    dispatch(
      updateEntry({
        guid,
        [`${labelType}_label`]: value,
      })
    )
  }

  const labelProps = {
    value: labelType === 'export' ? export_label : receipt_label,
    placeholder: ' ',
    id: `${guid}-${labelType}-label`,
    update: updateLabelValue,
    label: `${labelType[0].toUpperCase() + labelType.slice(1)} Label`,
    additionalClass: 'settings--inputs',
    maxLength: 30,
  }

  return (
    <div className="checkbox-label">
      <Input {...labelProps} />
    </div>
  )
}

export const LabelTextArea = ({ guid = '', report_label = '' }) => {
  const dispatch = useDispatch()

  const updateTextAreaValue = value => {
    dispatch(
      updateEntry({
        guid,
        report_label: value,
      })
    )
  }

  const textAreaProps = {
    placeholder: ' ',
    value: report_label,
    id: `${guid}-pdf-web-text-label`,
    update: updateTextAreaValue,
    label: 'PDF & Web Label',
    additionalClass: 'settings--inputs settings--static-text-input',
  }

  return (
    <div className="checkbox-textarea">
      <TextArea {...textAreaProps} />
    </div>
  )
}

export const PageBreakAfterToggle = ({
  guid = '',
  inserts_page_break_at_the_end = false,
}) => {
  const dispatch = useDispatch()

  return (
    <div className="page-break-after-toggle">
      <FancyToggle
        label="Page Break After "
        subLabel="(STANDARD PDF)"
        id={`${guid}--page-break-after-pdf`}
        active={inserts_page_break_at_the_end}
        inlineBorderStyle={true}
        onChange={checked => {
          dispatch(
            updateEntry({
              guid,
              inserts_page_break_at_the_end: checked,
            })
          )
        }}
      />
    </div>
  )
}

export const MobileVisible = ({ guid, visible = true }) => {
  const dispatch = useDispatch()

  return (
    <div className="page-break-after-toggle">
      <FancyToggle
        label="Mobile Visible"
        id={`${guid}--mobile-visible`}
        active={visible}
        inlineBorderStyle={true}
        onChange={checked => {
          dispatch(
            updateEntry({
              guid,
              visible: checked,
            })
          )
        }}
      />
    </div>
  )
}

export const PlaceValueIn = ({
  guid,
  auto_email_subject,
  auto_email_body,
  auto_email_filename,
  auto_submission_name,
}) => {
  const dispatch = useDispatch()
  return (
    <div className="place-value-in--checkboxes-wrapper show-this-field">
      <FancyCheckbox
        id={`${guid}--email-subject`}
        checked={auto_email_subject}
        onChange={() => {
          dispatch(
            updateEntry({
              guid,
              auto_email_subject: auto_email_subject ? false : true,
            })
          )
        }}
        label={'Email Subject'}
      />

      <FancyCheckbox
        id={`${guid}--email-body`}
        checked={auto_email_body}
        onChange={() => {
          dispatch(
            updateEntry({
              guid,
              auto_email_body: auto_email_body ? false : true,
            })
          )
        }}
        label={'Email Body'}
      />

      <FancyCheckbox
        id={`${guid}--email-file-name`}
        checked={auto_email_filename}
        onChange={() => {
          dispatch(
            updateEntry({
              guid,
              auto_email_filename: auto_email_filename ? false : true,
            })
          )
        }}
        label={'PDF File Name'}
      />

      <FancyCheckbox
        id={`${guid}--email-submission-name`}
        checked={auto_submission_name}
        onChange={() => {
          dispatch(
            updateEntry({
              guid,
              auto_submission_name: auto_submission_name ? false : true,
            })
          )
        }}
        label={'Submission Name'}
      />
    </div>
  )
}

export const DecimalPlaces = ({ type, guid, mask, style }) => {
  const dispatch = useDispatch()

  const options = [
    { value: null, label: 'No Limit' },
    { value: '0', label: 'No Decimal Places Allowed' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
  ]

  const value =
    style == CURRENCY_STYLE
      ? options[3]
      : options.find(({ value }) => value == mask) || options[1]

  return (
    <div className="settings--field-type">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        options={type === 'Number' ? options : options.slice(1)}
        value={value}
        isDisabled={style == CURRENCY_STYLE}
        onChange={({ value }) => {
          dispatch(updateEntry({ guid, mask: value }))
        }}
      />
      <label>Decimal Places</label>
    </div>
  )
}
